<div class="terms-and-conditions-container">
  @if (trustedHtml()) {
    <div class="ql-editor" [innerHTML]="trustedHtml()"></div>
  } @else {
    <h1>Terms &amp; Conditions: {{ storeName }}</h1>
    <p>
      Welcome to
      <strong>{{ storeName | titlecase }}</strong>
      , powered by
      <strong>{{ companyName }}</strong>
      . Please review the following Terms &amp; Conditions before placing an order. By accessing or
      purchasing from this store, you agree to these terms.
    </p>

    <h3>1. Custom-Made Products</h3>
    <p>
      All items offered in this store are
      <strong>made-to-order</strong>
      . Once an order is placed, it enters production promptly to ensure accurate fulfillment.
    </p>
    <ul>
      <li>
        Cancellations, changes, or returns due to ordering errors, sizing issues, or buyer’s remorse
        are not accepted.
      </li>
      <li>
        Please review product details and sizing guides carefully before confirming your purchase.
      </li>
    </ul>

    <h3>2. Production &amp; Shipping Timeline</h3>
    <p>Each order is crafted specifically for you. Please allow the following timeframes:</p>
    <ul>
      <li>
        <strong>Production Time:</strong>
        7 – 10 business days
      </li>
      <li>
        <strong>Shipping Time:</strong>
        2 – 7 business days (depending on destination and carrier)
      </li>
    </ul>
    <p>
      You will receive a tracking number once your order has shipped. Delivery times may vary during
      peak seasons or due to carrier delays beyond our control.
    </p>

    <h3>3. Returns &amp; Replacements</h3>
    <p>
      If your order arrives damaged, defective, or incorrect, contact us within
      <strong>7 days</strong>
      of delivery with your order number and clear photos of the issue. Eligible cases will receive
      a replacement at no additional cost.
    </p>
    <p>
      <em>
        Note: We do not offer refunds or exchanges for incorrect sizes or unwanted items due to the
        custom nature of each product.
      </em>
    </p>

    <h3>4. Shipping &amp; Delivery Policy</h3>
    <ul>
      <li>Please ensure your shipping address is correct at checkout.</li>
      <li>Undeliverable packages may incur reshipping fees.</li>
      <li>
        We are not liable for delays caused by carriers, weather, or unforeseen circumstances.
      </li>
    </ul>

    <h3>5. Order Support</h3>
    <p>
      For questions or concerns, contact us at:
      <a href="mailto:help@singleservemerch.com"><strong>help&#64;singleservemerch.com</strong></a>
      <br />
    </p>
    @if (contactEmails.length > 0) {
      <ul>
        @for (email of contactEmails; track $index) {
          <li>
            <a [href]="`mailto:${email}`">
              <strong>{{ email }}</strong>
            </a>
          </li>
        }
      </ul>
    }

    <h3>6. Payment Processing</h3>
    <p>
      All payments are securely processed at the time of purchase. Prices and availability are
      subject to change without notice.
    </p>

    <h3>7. Privacy</h3>
    <p>
      Your personal information is used solely for order processing and communication. We do not
      sell or share your data beyond what is necessary to fulfill your order. See our
      <a [routerLink]="privacyPolicyLink()">Privacy&nbsp;Policy</a>
      for more details.
    </p>

    <h3>8. Intellectual Property</h3>
    <p>
      All logos, designs, and branding featured in this store are the property of
      <strong>{{ storefrontId === 450 ? storeName : companyName }}</strong>
      and/or its affiliates. Unauthorized use is prohibited.
    </p>

    <h3>9. Governing Law</h3>
    <p>
      These Terms &amp; Conditions are governed by the laws of the state in which
      <strong>{{ companyName }}</strong>
      operates.
    </p>

    <p style="margin-top: 2rem">
      By completing a purchase, you confirm that you have read and agreed to these Terms &amp;
      Conditions.
    </p>
    <p></p>
    <p></p>
  }
</div>
